"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImpersonationToken = exports.GET_IMPERSONATION_TOKEN_SUCCESS = exports.GET_IMPERSONATION_TOKEN = exports.setImpersonationToken = exports.SET_IMPERSONATION_TOKEN = void 0;

var _appConstants = require("../constants/appConstants");

var SET_IMPERSONATION_TOKEN = "".concat(_appConstants.pkgName, "/SET_IMPERSONATION_TOKEN");
exports.SET_IMPERSONATION_TOKEN = SET_IMPERSONATION_TOKEN;

var setImpersonationToken = function setImpersonationToken(payload) {
  return {
    type: SET_IMPERSONATION_TOKEN,
    payload: payload
  };
};

exports.setImpersonationToken = setImpersonationToken;
var GET_IMPERSONATION_TOKEN = "@ikkiImpersonation/GET_IMPERSONATION_TOKEN";
exports.GET_IMPERSONATION_TOKEN = GET_IMPERSONATION_TOKEN;
var GET_IMPERSONATION_TOKEN_SUCCESS = "@ikkiImpersonation/GET_IMPERSONATION_TOKEN_SUCCESS";
exports.GET_IMPERSONATION_TOKEN_SUCCESS = GET_IMPERSONATION_TOKEN_SUCCESS;

var getImpersonationToken = function getImpersonationToken(payload) {
  return {
    type: GET_IMPERSONATION_TOKEN,
    payload: payload
  };
};

exports.getImpersonationToken = getImpersonationToken;